import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import {
  InfoModalContent,
  InfoModalHeader,
  InfoModalIcon,
  InfoModalBody,
  InfoModalText,
  InfoModalTitle,
  InfoModalList,
  InfoModalLink,
  InfoModalPrimaryLink,
  InfoModalFooter,
  InfoModalSecondaryButton,
  InfoModalPrimaryButton,
  ModalCloseButton,
} from './Modal.styles';
import { MegaphoneIcon, DocumentIcon } from './icons';

const InfoModal = ({ open, onClose }) => {


  const [innerWidth, setInnerWidth] = React.useState(window?.innerWidth || 0);

  React.useEffect(() => {
    const handleResize = () => setInnerWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={600}
      closable={false}
      style={{
        marginTop: innerWidth < 1400 ? 0 : undefined,
        top: innerWidth < 1400 ? 0 : undefined,
      }}
      bodyStyle={{ padding: 0 }}
    >
      {' '}
      <InfoModalContent>
        <InfoModalHeader>
          <InfoModalIcon>
            <MegaphoneIcon />
          </InfoModalIcon>
          <ModalCloseButton onClick={onClose}>
            <CloseOutlined />
          </ModalCloseButton>
        </InfoModalHeader>

        <InfoModalBody>
          <InfoModalText>
            Auf commonsplace gibt es freiwillige Möglichkeiten, Projekte
            zusätzlich sichtbar zu machen – auf der Plattform oder über
            ausgewählte Community-Kanäle.
          </InfoModalText>

          <InfoModalText>
            Keine Maßnahme startet ohne vorherige Abstimmung.
          </InfoModalText>

          <InfoModalTitle>Was sind Promotions?</InfoModalTitle>
          <InfoModalText>
            Eine Promotion bezeichnet zeitlich begrenzte Formen zusätzlicher
            Präsenz auf commonsplace oder innerhalb der Community.
          </InfoModalText>
          <InfoModalText>
            Sie dient als ergänzender Sichtbarkeits-Impuls und ersetzt weder
            Inhalte noch Engagement oder ein eigenes Netzwerk.
          </InfoModalText>
          <InfoModalText>
            Alle Projekte werden unabhängig davon regulär gelistet.
          </InfoModalText>

          <InfoModalText style={{ marginTop: '16px' }}>
            Formen der Sichtbarkeit:
          </InfoModalText>
          <InfoModalList>
            <li>
              <strong>Plattform-Sichtbarkeit:</strong> zeitlich begrenzte
              Hervorhebung auf{' '}
              <InfoModalLink href="https://commonsplace.de" target="_blank">
                commonsplace.de
              </InfoModalLink>
            </li>
            <li>
              <strong>Direkte Community-Kanäle:</strong> Erwähnungen über
              Newsletter oder WhatsApp
            </li>
            <li>
              <strong>Kombinierte Pakete:</strong> Kombinationen beider Formen,
              z. B. im Ramadan
            </li>
          </InfoModalList>

          <InfoModalTitle>Abrechnung & Transparenz</InfoModalTitle>
          <InfoModalText>Die Abrechnung erfolgt projektbezogen:</InfoModalText>
          <InfoModalList>
            <li>über die Projektgelder oder</li>
            <li>per separater Rechnung mit monatlicher Abrechnung.</li>
          </InfoModalList>
          <InfoModalText>
            Alle Konditionen werden vor Beginn transparent festgelegt.
          </InfoModalText>

          {/*<InfoModalPrimaryLink style={{ display: 'block', marginTop: '16px' }}>*/}
          {/*  Weitere Details finden sich im Infoblatt (PDF).*/}
          {/*</InfoModalPrimaryLink>*/}
        </InfoModalBody>

        <InfoModalFooter>
          <InfoModalSecondaryButton onClick={onClose}>
            Verstanden
          </InfoModalSecondaryButton>
          <InfoModalPrimaryButton onClick={onClose}>
            <DocumentIcon />
            Weitere Infos anzeigen
          </InfoModalPrimaryButton>
        </InfoModalFooter>
      </InfoModalContent>
    </Modal>
  );
};

InfoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default InfoModal;
